import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';

import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';
import { TrialExtensionReason } from '@zapier/design-system-revenue/src/types';

import { extendTrial as ExtendTrialData } from './types/extendTrial';

type Input = {
  reason: TrialExtensionReason;
  shouldAutoUpgrade?: boolean;
};

export const EXTEND_TRIAL = gql`
  mutation extendTrial(
    $accountId: ID!
    $reason: String!
    $shouldAutoUpgrade: Boolean
  ) {
    extendAccountTrial(
      id: $accountId
      reason: $reason
      shouldAutoUpgrade: $shouldAutoUpgrade
    ) {
      id
    }
  }
`;

export const useExtendTrial = ({
  reason,
  shouldAutoUpgrade = false,
}: Input) => {
  const { accountId } = useCurrentAccountId();

  const [extendTrial, { loading, error }] = useMutation<ExtendTrialData>(
    EXTEND_TRIAL,
    {
      variables: {
        accountId,
        reason,
        shouldAutoUpgrade,
      },
    }
  );

  return {
    extendTrial,
    error: error && error.message.replace('GraphQL error: ', ''),
    isLoading: loading,
  };
};
